import css from 'styled-jsx/css'
import { colors, fonts, measurements } from 'theme'

const calendarProps = {
  borderColor: colors.border,
  todayBackgroundColor: colors.badgeYellow,
  minCellHeight: '50px',
  minHeaderHeight: '70px',
  headerColor: colors.secondary,
  height: '845px'
}

const eventProps = {
  pendingValuationBackgroundColor: colors.primary,
  pendingShowBackgroundColor: colors.terciary,
  valuationBackgroundColor: colors.darkGray,
  showBackgroundColor: colors.gray,
}

export default css.global`
  .rbc-btn {
    color: inherit;
    font: inherit;
    margin: 0;
  }
  button.rbc-btn {
    overflow: visible;
    text-transform: none;
    -webkit-appearance: button;
    cursor: pointer;
  }
  button[disabled].rbc-btn {
    cursor: not-allowed;
  }
  button.rbc-input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
  .rbc-calendar {
    box-sizing: border-box;
    height: 100%;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-align-items: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
  }
  .rbc-calendar *,
  .rbc-calendar *:before,
  .rbc-calendar *:after {
    box-sizing: inherit;
  }
  .rbc-abs-full,
  .rbc-row-bg {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .rbc-ellipsis,
  .rbc-event-label,
  .rbc-row-segment .rbc-event-content,
  .rbc-show-more {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .rbc-rtl {
    direction: rtl;
  }
  .rbc-off-range {
    color: ${colors.dirtGray};
  }
  .rbc-off-range-bg {
    background: ${colors.grayBackground};
  }
  .rbc-header {
    overflow: hidden;
    -webkit-flex: 1 0 0%;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 3px;
    text-align: center;
    vertical-align: middle;
    font-weight: bold;
    font-size: 90%;
    min-height: 0;
    border-bottom: 1px solid ${colors.lightDullGray};
  }
  .rbc-header + .rbc-header {
    border-left: 1px solid ${colors.lightDullGray};
  }
  .rbc-rtl .rbc-header + .rbc-header {
    border-left-width: 0;
    border-right: 1px solid ${colors.lightDullGray};
  }
  .rbc-header > a,
  .rbc-header > a:active,
  .rbc-header > a:visited {
    color: inherit;
    text-decoration: none;
  }
  .rbc-row-content {
    position: relative;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-select: none;
    z-index: 4;
  }
  .rbc-today {
    background-color: ${colors.textBlueBackground};
  }
  .rbc-toolbar {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 10px;
    font-size: 16px;
  }
  .rbc-toolbar .rbc-toolbar-label {
    -webkit-flex-grow: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    padding: 0 10px;
    text-align: center;
  }
  .rbc-toolbar button {
    color: ${colors.leatherBlack};
    display: inline-block;
    margin: 0;
    text-align: center;
    vertical-align: middle;
    background: none;
    background-image: none;
    border: 1px solid ${colors.lightDullGray};
    padding: 0.375rem 1rem;
    border-radius: 4px;
    line-height: normal;
    white-space: nowrap;
  }
  .rbc-toolbar button:active,
  .rbc-toolbar button.rbc-active {
    background-image: none;
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    background-color: ${colors.lightBg};
    border-color: ${colors.borderInput};
  }
  .rbc-toolbar button:active:hover,
  .rbc-toolbar button.rbc-active:hover,
  .rbc-toolbar button:active:focus,
  .rbc-toolbar button.rbc-active:focus {
    color: ${colors.leatherBlack};
    background-color: ${colors.lightDullGray};
    border-color: ${colors.dirtGray};
  }
  .rbc-toolbar button:focus {
    color: ${colors.leatherBlack};
    background-color: ${colors.lightBg};
    border-color: ${colors.borderInput};
  }
  .rbc-toolbar button:hover {
    color: ${colors.leatherBlack};
    background-color: ${colors.lightBg};
    border-color: ${colors.borderInput};
  }
  .rbc-btn-group {
    display: inline-block;
    white-space: nowrap;
  }
  .rbc-btn-group > button:first-child:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .rbc-btn-group > button:last-child:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {
    border-radius: 4px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {
    border-radius: 4px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .rbc-btn-group > button:not(:first-child):not(:last-child) {
    border-radius: 0;
  }
  .rbc-btn-group button + button {
    margin-left: -1px;
  }
  .rbc-rtl .rbc-btn-group button + button {
    margin-left: 0;
    margin-right: -1px;
  }
  .rbc-btn-group + .rbc-btn-group,
  .rbc-btn-group + button {
    margin-left: 10px;
  }
  .rbc-event {
    padding: 2px 5px;
    background-color: ${colors.babyBlue};
    border-radius: 5px;
    color: ${colors.white};
    cursor: pointer;
    z-index: 11;
  }
  .rbc-slot-selecting .rbc-event {
    cursor: inherit;
    pointer-events: none;
  }
  .rbc-event.rbc-selected {
    background-color: ${colors.indigo};
  }
  .rbc-event-label {
    font-size: 80%;
  }
  .rbc-event-overlaps {
    box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
  }
  .rbc-event-continues-prior {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .rbc-event-continues-after {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .rbc-event-continues-earlier {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .rbc-event-continues-later {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .rbc-event-continues-day-after {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .rbc-event-continues-day-prior {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .rbc-row {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
  }
  .rbc-row-segment {
    padding: 0 1px 1px 1px;
  }
  .rbc-selected-cell {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .rbc-show-more {
    background-color: rgba(255, 255, 255, 0.3);
    z-index: 4;
    font-weight: bold;
    font-size: 85%;
    height: auto;
    line-height: normal;
    white-space: nowrap;
  }
  .rbc-month-view {
    position: relative;
    border: 1px solid ${colors.lightDullGray};
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex: 1 0 0;
    -ms-flex: 1 0 0px;
    flex: 1 0 0;
    width: 100%;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-select: none;
    height: 100%;
  }
  .rbc-month-header {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
  }
  .rbc-month-row {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex: 1 0 0;
    -ms-flex: 1 0 0px;
    flex: 1 0 0;
    -webkit-flex-basis: 0px;
    -ms-flex-preferred-size: 0px;
    flex-basis: 0px;
    overflow: hidden;
    height: 100%;
  }
  .rbc-month-row + .rbc-month-row {
    border-top: 1px solid ${colors.lightDullGray};
  }
  .rbc-date-cell {
    -webkit-flex: 1 1 0;
    -ms-flex: 1 1 0px;
    flex: 1 1 0;
    min-width: 0;
    padding-right: 5px;
    text-align: right;
  }
  .rbc-date-cell.rbc-now {
    font-weight: bold;
  }
  .rbc-date-cell > a,
  .rbc-date-cell > a:active,
  .rbc-date-cell > a:visited {
    color: inherit;
    text-decoration: none;
  }
  .rbc-row-bg {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex: 1 0 0;
    -ms-flex: 1 0 0px;
    flex: 1 0 0;
    overflow: hidden;
  }
  .rbc-day-bg {
    -webkit-flex: 1 0 0%;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
  }
  .rbc-day-bg + .rbc-day-bg {
    border-left: 1px solid ${colors.lightDullGray};
  }
  .rbc-rtl .rbc-day-bg + .rbc-day-bg {
    border-left-width: 0;
    border-right: 1px solid ${colors.lightDullGray};
  }
  .rbc-overlay {
    position: absolute;
    z-index: 5;
    border: 1px solid ${colors.lighterGray};
    background-color: ${colors.white};
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
    padding: 10px;
  }
  .rbc-overlay > * + * {
    margin-top: 1px;
  }
  .rbc-overlay-header {
    border-bottom: 1px solid ${colors.lighterGray};
    margin: -10px -10px 5px -10px;
    padding: 2px 10px;
  }
  .rbc-agenda-view {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex: 1 0 0;
    -ms-flex: 1 0 0px;
    flex: 1 0 0;
    overflow: auto;
  }
  .rbc-agenda-view table.rbc-agenda-table {
    width: 100%;
    border: 1px solid ${colors.lightDullGray};
    border-spacing: 0;
    border-collapse: collapse;
  }
  .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
    padding: 5px 10px;
    vertical-align: top;
  }
  .rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {
    padding-left: 15px;
    padding-right: 15px;
    text-transform: lowercase;
  }
  .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
    border-left: 1px solid ${colors.lightDullGray};
  }
  .rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
    border-left-width: 0;
    border-right: 1px solid ${colors.lightDullGray};
  }
  .rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
    border-top: 1px solid ${colors.lightDullGray};
  }
  .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
    padding: 3px 5px;
    text-align: left;
    border-bottom: 1px solid ${colors.lightDullGray};
  }
  .rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
    text-align: right;
  }
  .rbc-agenda-time-cell {
    text-transform: lowercase;
  }
  .rbc-agenda-time-cell .rbc-continues-after:after {
    content: ' »';
  }
  .rbc-agenda-time-cell .rbc-continues-prior:before {
    content: '« ';
  }
  .rbc-agenda-date-cell,
  .rbc-agenda-time-cell {
    white-space: nowrap;
  }
  .rbc-agenda-event-cell {
    width: 100%;
  }
  .rbc-time-column {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    min-height: 100%;
  }
  .rbc-time-column .rbc-timeslot-group {
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }
  .rbc-timeslot-group {
    border-bottom: 1px solid ${colors.lightDullGray};
    min-height: 5rem;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-flow: column nowrap;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
  }
  .rbc-time-gutter,
  .rbc-header-gutter {
    -webkit-flex: none;
    -ms-flex: none;
    flex: none;
  }
  .rbc-label {
    padding: 0 5px;
  }
  .rbc-day-slot {
    position: relative;
  }
  .rbc-day-slot .rbc-events-container {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 10px;
    top: 0;
  }
  .rbc-day-slot .rbc-events-container.rbc-is-rtl {
    left: 10px;
    right: 0;
  }
  .rbc-day-slot .rbc-event {
    border: 1px solid ${colors.indigo};
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    max-height: 100%;
    min-height: 20px;
    -webkit-flex-flow: column wrap;
    -ms-flex-flow: column wrap;
    flex-flow: column wrap;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    overflow: hidden;
    position: absolute;
  }
  .rbc-day-slot .rbc-event-label {
    -webkit-flex: none;
    -ms-flex: none;
    flex: none;
    padding-right: 5px;
    width: auto;
  }
  .rbc-day-slot .rbc-event-content {
    width: 100%;
    -webkit-flex: 1 1 0;
    -ms-flex: 1 1 0px;
    flex: 1 1 0;
    word-wrap: break-word;
    line-height: 1;
    height: 100%;
    min-height: 1em;
  }
  .rbc-day-slot .rbc-time-slot {
    border-top: 1px solid ${colors.lighterGray};
  }
  .rbc-time-slot {
    -webkit-flex: 1 0 0;
    -ms-flex: 1 0 0px;
    flex: 1 0 0;
  }
  .rbc-time-slot.rbc-now {
    font-weight: bold;
  }
  .rbc-day-header {
    text-align: center;
  }
  .rbc-slot-selection {
    z-index: 10;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 75%;
    width: 100%;
    padding: 3px;
  }
  .rbc-slot-selecting {
    cursor: move;
  }
  .rbc-time-view {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 100%;
    border: 1px solid ${colors.lightDullGray};
    min-height: 0;
  }
  .rbc-time-view .rbc-time-gutter {
    white-space: nowrap;
  }
  .rbc-time-view .rbc-allday-cell {
    box-sizing: content-box;
    width: 100%;
    position: relative;
  }
  .rbc-time-view .rbc-allday-events {
    position: relative;
    z-index: 4;
  }
  .rbc-time-view .rbc-row {
    box-sizing: border-box;
    min-height: 20px;
  }
  .rbc-time-header {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex: 0 0 auto;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
  }
  .rbc-time-header.rbc-overflowing {
    border-right: 1px solid ${colors.lightDullGray};
  }
  .rbc-rtl .rbc-time-header.rbc-overflowing {
    border-right-width: 0;
    border-left: 1px solid ${colors.lightDullGray};
  }
  .rbc-time-header > .rbc-row:first-child {
    border-bottom: 1px solid ${colors.lightDullGray};
  }
  .rbc-time-header > .rbc-row.rbc-row-resource {
    border-bottom: 1px solid ${colors.lightDullGray};
  }
  .rbc-time-header-content {
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    min-width: 0;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    border-left: 1px solid ${colors.lightDullGray};
  }
  .rbc-rtl .rbc-time-header-content {
    border-left-width: 0;
    border-right: 1px solid ${colors.lightDullGray};
  }
  .rbc-time-content {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex: 1 0 0%;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    width: 100%;
    border-top: 2px solid ${colors.lightDullGray};
    overflow-y: auto;
    position: relative;
  }
  .rbc-time-content > .rbc-time-gutter {
    -webkit-flex: none;
    -ms-flex: none;
    flex: none;
  }
  .rbc-time-content > * + * > * {
    border-left: 1px solid ${colors.lightDullGray};
  }
  .rbc-rtl .rbc-time-content > * + * > * {
    border-left-width: 0;
    border-right: 1px solid ${colors.lightDullGray};
  }
  .rbc-time-content > .rbc-day-slot {
    width: 100%;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-select: none;
  }
  .rbc-current-time-indicator {
    position: absolute;
    z-index: 3;
    height: 1px;
    background-color: ${colors.limeGreen};
    pointer-events: none;
  }
`

export const overwrites = css`
  .day {
    color: ${colors.secondary};
  }
  .month {
    color: ${colors.secondary};
  }
  .header {
    color: ${colors.secondary};
  }
  .rbc-today {
    background-color: ${calendarProps.todayBackgroundColor};
  }
  .rbc-toolbar .rbc-toolbar-label {
    width: 100%;
    padding: 0 10px;
    text-align: center;
    font: ${fonts.bold};
    color: ${colors.secondary};
  }
  .rbc-month-view {
    position: relative;
    border: 1px solid ${calendarProps.borderColor};
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex: 1 0 0;
    -ms-flex: 1 0 0px;
    flex: 1 0 0;
    width: 100%;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    height: 100%;
  }
  .rbc-month-view .rbc-header {
    border-bottom: 1px solid ${calendarProps.borderColor};
  }
  .rbc-month-view .rbc-header + .rbc-header {
    border-left: 1px solid ${calendarProps.borderColor};
  }
  .rbc-rtl .rbc-month-view .rbc-header + .rbc-header {
    border-left-width: 0;
    border-right: 1px solid ${calendarProps.borderColor};
  }
  .rbc-month-row + .rbc-month-row {
    border-top: 1px solid ${calendarProps.borderColor};
  }
  .rbc-day-bg + .rbc-day-bg {
    border-left: 1px solid ${calendarProps.borderColor};
  }
  .rbc-rtl .rbc-day-bg + .rbc-day-bg {
    border-left-width: 0;
    border-right: 1px solid ${calendarProps.borderColor};
  }
  .rbc-agenda-view table tbody > tr > td + td {
    border-left: 1px solid ${calendarProps.borderColor};
  }
  .rbc-rtl .rbc-agenda-view table tbody > tr > td + td {
    border-left-width: 0;
    border-right: 1px solid ${calendarProps.borderColor};
  }
  .rbc-agenda-view table tbody > tr + tr {
    border-top: 1px solid ${calendarProps.borderColor};
  }
  .rbc-agenda-view table thead > tr > th {
    padding: 3px 5px;
    text-align: left;
    border-bottom: 1px solid ${calendarProps.borderColor};
  }
  .rbc-timeslot-group {
    border-bottom: 1px solid ${calendarProps.borderColor};
    min-height: ${calendarProps.minCellHeight};
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-flow: column nowrap;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
  }
  .rbc-time-slot > span {
    color: ${colors.secondary};
  }
  .rbc-time-view {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 100%;
    border: 1px solid ${calendarProps.borderColor};
    min-height: 0;
  }
  .rbc-time-header.rbc-overflowing {
    border-right: 1px solid ${calendarProps.borderColor};
  }
  .rbc-rtl .rbc-time-header.rbc-overflowing {
    border-right-width: 0;
    border-left: 1px solid ${calendarProps.borderColor};
  }
  .rbc-time-header > .rbc-row > * + * {
    border-left: 1px solid ${calendarProps.borderColor};
  }
  .rbc-rtl .rbc-time-header > .rbc-row > * + * {
    border-left-width: 0;
    border-right: 1px solid ${calendarProps.borderColor};
  }
  .rbc-time-header > .rbc-row:first-child {
    border-bottom: 1px solid ${calendarProps.borderColor};
  }
  .rbc-time-content {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex: 1 0 0%;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    width: 100%;
    border-top: 2px solid ${calendarProps.borderColor};
    overflow-y: auto;
    position: relative;
  }
  .rbc-time-content > * + * > * {
    border-left: 1px solid ${calendarProps.borderColor};
  }
  .rbc-rtl .rbc-time-content > * + * > * {
    border-left-width: 0;
    border-right: 1px solid ${calendarProps.borderColor};
  }
  .list {
    color: ${colors.secondary};
  }
`

export const containerHeader = css`
  .header {
    background-color: ${colors.white};
    border: solid 1px ${colors.border};
    font: 700 1rem 'Source Sans Pro', sans-serif;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
  }
`

export const responsiveContainer = css`
  @media (max-width: 991px) {
    .responsive-calendar {
      display: none;
    }
  }
`

export const container = css`
  .container {
    display: flex;
    margin: 20px auto;
    width: 90%;
    font-size: 14px;
    overflow-y: auto;
    max-width: ${measurements.containerSize};
  }

  .container .calendar {
    max-width: ${measurements.containerSize};
  }

  .container :global(> :first-child) {
    flex-grow: 1;
    flex-shrink: 1;
  }

  .container :global(.rbc-calendar) {
    flex-grow: 1;
    flex-shrink: 1;
    height: auto;
    background-color: ${colors.white};
    min-height: ${calendarProps.height};
  }

  .container :global(.rbc-time-slot.rbc-label) {
    font-weight: 600;
    text-align: center;
    padding-top: 5px;
  }

  .container :global(.rbc-toolbar button.rbc-active) {
    box-shadow: none;
  }

  .container :global(.rbc-header) {
    font-weight: 600;
    min-height: ${calendarProps.minHeaderHeight};
  }

  .container :global(.rbc-header.rbc-today) {
    background-color: transparent;
  }

  .container :global(.rbc-event) {
    border-radius: 0;
    border: none;
    background: none;
    padding: 0;
  }

  .container :global(.rbc-event-label) {
    display: none;
  }

  .container :global(.rbc-time-view .rbc-time-header .rbc-row:last-child) {
    display: none;
  }

  @media screen and (max-width: 992px) {
    .container {
      width: 99%;
    }
  }
`

export const toolbar = css`
  .toolbar {
    flex-wrap: wrap;
    position: relative;
    padding: 20px 25px;
    margin: 0;
    min-height: 70px;
    height: auto;
    border: solid 1px ${calendarProps.borderColor};
  }
  .btn-container {
    display: flex;
    flex-direction: row;
  }
  .btn-container :global(.btn) {
    margin-right: 10px;
  }
  .btn-container :global(.btn-text) {
    font-size: 19px;
  }
  .btn-container.view-selector {
    position: absolute;
    top: 20px;
    right: 10px;
  }
  @media (max-width: 991px) {
    :global(.rbc-toolbar .rbc-toolbar-label) {
      width: 50%;
    }
  }
  @media (max-width: 991px) {
    .btn-container.view-selector :global(.view-month) {
      display: none;
    }
    .btn-container.view-selector :global(.view-week) {
      border-radius: 1.375rem;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .rbc-toolbar .rbc-toolbar-label {
      padding-top: 60px;
      padding-bottom: 10px;
    }
  }
  @media (max-width: 1224px) {
    .rbc-toolbar .rbc-toolbar-label {
      padding-top: 60px;
      padding-bottom: 10px;
    }
  }
  .btn-container.navigation {
    position: absolute;
    top: 20px;
    left: 10px;
  }
`

export const dayHeader = css`
  .header {
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    font-size: 14px;
    text-align: center;
  }
  .header .day {
    color: gray;
  }
`

export const event = css`
  .event {
    display: flex;
    height: 100%;
    flex-direction: column;
    font: ${fonts.bold};
    position: relative;
    background-color: ${colors.gray};
  }
  .event :global(p) {
    margin: 3px;
  }
  .user {
    font: ${fonts.semiBold};
    font-size: 0.875rem;
  }

  .radio-button {
    position: absolute;
    border: 1px solid;
    border-radius: 50%;
    width: 8.1px;
    height: 8.1px;
    bottom: 4px;
    right: 4px;
  }
  .event :global(.hour) {
    font: ${fonts.bold};
    font-size: 0.625rem;
  }
  .event :global(.user) {
    font-weight: ${fonts.semiBold};
    font-size: 0.875rem;
  }
  .event :global(.address) {
    font-weight: ${fonts.semiBold};
    font-size: 0.725rem;
  }
  .pending.broker_valuation {
    background-color: ${colors.danger};
  }
  .confirmed.broker_valuation {
    background-color: ${colors.text};
  }
  .valuation {
    background-color: ${eventProps.valuationBackgroundColor};
  }
  .show {
    background-color: ${eventProps.showBackgroundColor};
  }
  .pending.valuation {
    background-color: ${eventProps.pendingValuationBackgroundColor};
  }
  .pending.show {
    background-color: ${eventProps.pendingShowBackgroundColor};
  }
  .confirmed.custom_event {
    background-color: ${colors.badge};
  }
  .radio-button.success {
    background-color: ${colors.success};
  }
  .radio-button.confirmed {
    background-color: ${colors.danger};
  }
  .radio-button.pending {
    background-color: ${colors.warning};
  }
`
